import gate from '@/api/axios';

/**
 * Добавляет время к таймеру
 * @param id
 * @param days
 * @returns {Promise<AxiosResponse<any>>}
 */
export const orderResetTimer = async (id, days = 1) => gate.post(`/orders/${id}/reset-timer`, { period: days });

/**
 * Врзвращает заказ в эфир
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const orderReturn = async (id) => gate.post(`/orders/${id}/return`);

/**
 * Скачать логи
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const orderDownloadLogs = async (id) => gate.get(`/orders/${id}/logs?limit=1000`);

/**
 * Получить ссылку на оплату заказа
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const orderPaymentLink = async (id) => gate.get(`/orders/${id}/get-payment-link`);

/**
 * Получает список заказов
 * @async
 * @function ordersSearch
 * @param {Object} payload
 * @returns {Promise}
 */
export const ordersSearch = async (payload) => gate.get('/orders', {
  params: payload,
});

/**
 * Получает модель заказа
 * @async
 * @function orderDetails
 * @param {Number|String} id ID заказа
 * @returns {Promise}
 */
export const orderDetails = async (id) => gate.get(`/orders/${id}`);

/**
 * Присоединиться к заказу
 * @async
 * @function joinOrder
 * @param {Number|String} id ID заказа
 * @returns {Promise}
 */
export const joinOrder = async (id) => gate.post(`/orders/${id}/join`);

/**
 * Получить сообщения чата по заказу
 * @async
 * @function fetchChatMessages
 * @param {Number|String} id ID заказа
 * @returns {Promise}
 */
export const fetchChatMessages = async (id, payload) => gate.get(`/orders/${id}/chatMessages`, {
  params: payload,
});

/**
 * Отправляет сообщение в чат
 * @async
 * @function sendChatMessage
 * @param {Number|String} id ID заказа
 * @param {Object} payload
 * @returns {Promise}
 */
export const sendChatMessage = async (id, payload) => gate.post(`/orders/${id}/chatMessages`, payload);

/**
 * Отменяет заказ
 * @async
 * @function cancelOrder
 * @param {Number|String} id ID заказа
 * @param {Object} payload
 * @returns {Promise}
 */
export const cancelOrder = async (id, payload) => gate.post(`/orders/${id}/workflow/cancel`, payload);

/**
 * Назначает исполнителя на заказ
 * @async
 * @function orderAssign
 * @param {Number|String} id ID заказа
 * @param {Object} payload
 * @returns {Promise}
 */
export const orderAssign = async (id, payload) => gate.post(`/orders/${id}/workflow/assign`, payload);

/**
 * Закрывает заказ
 * @async
 * @function orderClose
 * @param {Number|String} id ID заказа
 * @param {Object} payload
 * @returns {Promise}
 */
export const orderClose = async (id, payload) => gate.post(`/orders/${id}/workflow/close`, payload);

/**
 * Принудительная выплата по заказу
 * @param id
 * @returns {Promise}
 */
export const orderPayout = async (id) => gate.post(`/orders/${id}/payment`);

export const orderUpdateCommissionPercent = async (id, payload) => gate.post(`/orders/${id}/update-commission`, payload);
